import { useContext, useState } from 'react'
import { DeleteOutlined } from '@mui/icons-material'
import { Button } from '@mui/material'

import Subsection from '../../../../components/subsection'
import { useAuthentication } from '../../../../providers/auth-provider'
import { WRITE_PERMISSIONS_LIST } from '../../../../utils/constants/permissions'
import PeopleContext from '../../context'
import useStyles from '../../index.styles'

import ChangePasswordModal from './change-password-modal'
import DeleteModal from './delete-modal'

const ManageContent = () => {
  const classes = useStyles

  const { ownUser, ownPermissions } = useAuthentication()
  const { user, loading } = useContext(PeopleContext)

  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [showChangePasswordModal, setShowChangePasswordModal] = useState<boolean>(false)

  const canWriteUsers = ownPermissions.length > 0 && ownPermissions.find((p) => p.name === WRITE_PERMISSIONS_LIST.users.name)

  return (
    <>
      {((ownUser && ownUser.id === user?.id) || (ownUser?.id !== user?.id && canWriteUsers)) && (
        <div style={classes.subsectionContainer}>
          {ownUser && ownUser.id === user?.id && (
            <Subsection
              header="Security"
              content={
                <Button variant="text" size="small" color="primary" onClick={() => setShowChangePasswordModal(true)}>
                  Change Password
                </Button>
              }
              loading={loading}
            />
          )}
          {ownUser?.id !== user?.id && canWriteUsers && (
            <Subsection
              header="Account"
              content={
                <Button variant="text" size="small" color="error" startIcon={<DeleteOutlined />} onClick={() => setShowDeleteModal(true)}>
                  Delete
                </Button>
              }
              loading={loading}
            />
          )}
        </div>
      )}

      <DeleteModal open={showDeleteModal} setOpen={setShowDeleteModal} />
      <ChangePasswordModal open={showChangePasswordModal} setOpen={setShowChangePasswordModal} />
    </>
  )
}

export default ManageContent
